import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/__root';
import { indexRoute } from '@/routes';
import { checkoutRoute } from './routes/checkout';
import { signinRoute } from './routes/signin';
import { redirectRoute } from './routes/redirect';

const routeTree = rootRoute.addChildren([
  indexRoute,
  checkoutRoute,
  signinRoute,
  redirectRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
